import React from "react";

const QuizOption = ({
  children,
  value,
  name,
  onClick,
  className = "",
  hasIcon = false,
  defaultChecked = false,
}) => {
  const optionClass = `quiz-option ${
    hasIcon ? "quiz-option-with-icon" : ""
  } ${className}`;

  const handleClick = (e) => {
    e.preventDefault();
    onClick(value);
  };

  return (
    <label className={optionClass} onClick={handleClick}>
      <input
        type="radio"
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        readOnly
      />
      {children}
    </label>
  );
};

export default QuizOption;
